import { render, staticRenderFns } from "./updateWeight.vue?vue&type=template&id=fa6bdd04&scoped=true&"
import script from "./updateWeight.vue?vue&type=script&lang=js&"
export * from "./updateWeight.vue?vue&type=script&lang=js&"
import style0 from "./updateWeight.vue?vue&type=style&index=0&id=fa6bdd04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6bdd04",
  null
  
)

export default component.exports